<template>
  <div>
    <div class="d-flex justify-content-around">
      <div class="form-group pr-0 pl-0 mr-4 w-100">
        <div class="input-group">
            <va-input
              :label="$t('tags.form.name')"
              :maxlength="255"
              :placeholder="$t('tags.form.name_placeholder')"
              v-model="form.name"
              type="text"
              :error="validationErrors.has('name')"
              :error-messages="[$t(validationErrors.get('name'))]"
              />
          </div>
      </div>
      <va-color-picker-input mode="advanced" v-model="form.color" class="mt-2">
        <div class="color__item" :style="{'background-color': form.color, 'width': '30px', 'height': '30px', 'border-radius': '50%'}"></div>
      </va-color-picker-input>
    </div>

    <div class="d-flex">
      <span>
        <b>{{$t('tags.form.visibility', {entityName: this.$auth.user().entity.name})}}</b>
      </span>
    </div>
    <div class="d-flex align-items-center">
      <small class="w-85">{{$t('tags.form.visibility__tooltip', {entityName: this.$auth.user().entity.name})}}</small>

      <slider v-model="form.visibility"></slider>
    </div>

    <br>
    <div class="d-flex justify-content-center pb-5 pt-2">
      <div v-if="isEditingTag">
        <button class="btn-cancelar btn btn-primary btn-micro" @click="cancelUpdateTag()">{{$t('modals.defaults.button_cancel')}}</button>
      </div>
      &nbsp;
      <div>
        <button v-if="!isEditingTag" class="btn btn-primary btn-micro" @click="saveTag()" :disabled="isSubmiting">{{$t('modals.defaults.button_add')}}</button>
        <button v-else class="btn btn-primary btn-micro" @click="updateTag()" :disabled="isSubmiting">{{$t('modals.defaults.button_save')}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import Slider from '@/components/common/Slider'
import Errors from '@/utils/StandardErrors'

const errorsPrefix = 'tags.validationsMessages.'

export default {
  components: {
    Slider
  },
  props: {
    isEditingTag: {
      type: Boolean,
      required: false,
      default: false
    },
    selectedTag: {
      type: Object,
      required: false,
      default: () => {
        return {
          name: '',
          color: '#23c4ba',
          visibility: false
        }
      }
    },
    baseTagStyles: {
      type: Object,
      required: false,
      default: () => {
        return {
          width: '30px',
          heigth: '30px',
          'border-radius': '50%'
        }
      }
    }
  },
  data () {
    return {
      form: this.selectedTag,
      validationErrors: new Errors(),
      isSubmiting: false
    }
  },
  methods: {
    cancelUpdateTag: function () {
      this.$emit('cancelUpdateTag')
      this.resetForm()
    },
    saveTag: function () {
      this.isSubmiting = true
      this.$http({
        url: `${this.$store.state.evollead_server}/tags`,
        method: 'POST',
        data: this.form
      }).then((response) => {
        console.log(response)
        this.$emit('newTagAdded', response.data.data)
        this.resetForm()
      }).catch((err) => {
        if (err.response.status === 422) {
          this.validationErrors.record(err.response.data, errorsPrefix)
        } else {
          this.showToast(`${this.$t(errorsPrefix)}generic_error`)
        }
      }).finally(() => {
        setTimeout(() => {
          this.isSubmiting = false
        }, 300)
      })
    },
    updateTag: function () {
      this.isSubmiting = true
      this.$http({
        url: `${this.$store.state.evollead_server}/tags/${this.selectedTag.id}`,
        method: 'PATCH',
        data: this.form
      }).then((response) => {
        this.$emit('newTagUpdated', response.data.data)
        this.resetForm()
      }).catch((err) => {
        console.log(err)
      }).finally(() => {
        setTimeout(() => {
          this.isSubmiting = false
        }, 300)
      })
    },
    resetForm: function () {
      this.form = {
        name: '',
        color: '#23c4ba',
        visibility: false
      }
      this.validationErrors.errors = {}
    }
  },
  watch: {
    selectedTag: {
      handler: function (value) {
        this.form = value
      },
      deep: true
    }
  }
}
</script>
